export const state = () => {
    return {
        toggle: false
    }
}
export const mutations = {
    SET_TOGGLE(state, toggle = null) {
        if (toggle === null) {
            state.toggle = !state.toggle
        } else {
            state.toggle = toggle
        }
    }
}
export const actions = {}
